/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ZbaWXJHpq",
    "aws_user_pools_web_client_id": "2rteg47ricv941apnl92k7jvnk",
    "oauth": {
        "domain": "test.presagetech.com.auth.us-east-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": "http://localhost:5175/auth/desktop-callback/index.html,https://test.app.presagetech.com/,https://test.app.presagetech.com/admin/auth/callback,https://test.app.presagetech.com/auth/desktop-callback/index.html,https://test.app.presagetech.com/liveline/auth/callback,https://test.presagetech.com/,presage-vcam://auth/callback,presagevitals://auth/callback",
        "redirectSignOut": "https://test.app.presagetech.com/admin/logout,https://test.app.presagetech.com/liveline/logout,https://test.app.presagetech.com/logout,https://test.presagetech.com/login",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 12,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
